import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';
import LandingPage from './pages/LandingPage';
import ClienteDashboard from './pages/ClienteDashboard';
import ArquitetoDashboard from './pages/ArquitetoDashboard';
import DashboardAssistente from './pages/DashboardAssistente';
import ProjetoDetalhe from './pages/ProjetoDetalhe';
import UsuariosCRUD from './pages/UsuariosCRUD';
import TiposEtapaCRUD from './pages/TiposEtapaCRUD';
import ProjetoWizard from './pages/ProjetoWizard';
import ApontamentoForm from './pages/ApontamentoForm';
import AtividadeDetalhe from './pages/AtividadeDetalhe';
import ProjetoEditar from './pages/ProjetoEditar';
import EsqueciSenha from './pages/EsqueciSenha/EsqueciSenha';
import TrocaSenhaObrigatoria from './pages/TrocaSenhaObrigatoria/TrocaSenhaObrigatoria';
import PoliticaPrivacidade from './pages/legal/PoliticaPrivacidade';
import PoliticaCookies from './pages/legal/PoliticaCookies';
import TermosUso from './pages/legal/TermosUso';
import LGPD from './pages/legal/LGPD';
import RedefinirSenha from './pages/RedefinirSenha/RedefinirSenha';
import NotificacoesConfig from './pages/Notificacoes/NotificacoesConfig';
import AdminConteudo from './pages/AdminConteudo/AdminConteudo';

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes — standalone, no layout */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/esqueci-senha" element={<EsqueciSenha />} />
      <Route path="/trocar-senha" element={<TrocaSenhaObrigatoria />} />
      <Route path="/redefinir-senha" element={<RedefinirSenha />} />
      <Route path="/privacidade" element={<PoliticaPrivacidade />} />
      <Route path="/cookies" element={<PoliticaCookies />} />
      <Route path="/termos" element={<TermosUso />} />
      <Route path="/lgpd" element={<LGPD />} />

      {/* Protected routes wrapped in AppLayout */}
      <Route
        element={
          <ProtectedRoute allowedTypes={['Cliente', 'Arquiteto', 'Assistente', 'Master']}>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        {/* Cliente */}
        <Route
          path="/empreendimentos"
          element={
            <ProtectedRoute allowedTypes={['Cliente']}>
              <ClienteDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notificacoes"
          element={
            <ProtectedRoute allowedTypes={['Cliente']}>
              <NotificacoesConfig />
            </ProtectedRoute>
          }
        />

        {/* Arquiteto */}
        <Route
          path="/painel"
          element={
            <ProtectedRoute allowedTypes={['Arquiteto']}>
              <ArquitetoDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/painel/empreendimentos"
          element={
            <ProtectedRoute allowedTypes={['Arquiteto']}>
              <DashboardAssistente />
            </ProtectedRoute>
          }
        />
        <Route
          path="/painel/empreendimentos/novo"
          element={
            <ProtectedRoute allowedTypes={['Arquiteto']}>
              <ProjetoWizard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/painel/usuarios"
          element={
            <ProtectedRoute allowedTypes={['Arquiteto']}>
              <UsuariosCRUD />
            </ProtectedRoute>
          }
        />
        <Route
          path="/painel/tipos-etapa"
          element={
            <ProtectedRoute allowedTypes={['Arquiteto']}>
              <TiposEtapaCRUD />
            </ProtectedRoute>
          }
        />
        <Route
          path="/painel/empreendimentos/:id/editar"
          element={
            <ProtectedRoute allowedTypes={['Arquiteto']}>
              <ProjetoEditar />
            </ProtectedRoute>
          }
        />

        {/* Assistente */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedTypes={['Assistente']}>
              <DashboardAssistente />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/empreendimentos"
          element={
            <ProtectedRoute allowedTypes={['Assistente']}>
              <DashboardAssistente />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/usuarios"
          element={
            <ProtectedRoute allowedTypes={['Assistente']}>
              <UsuariosCRUD />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/tipos-etapa"
          element={
            <ProtectedRoute allowedTypes={['Assistente']}>
              <TiposEtapaCRUD />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/empreendimentos/novo"
          element={
            <ProtectedRoute allowedTypes={['Assistente']}>
              <ProjetoWizard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/empreendimentos/:id/editar"
          element={
            <ProtectedRoute allowedTypes={['Assistente']}>
              <ProjetoEditar />
            </ProtectedRoute>
          }
        />

        {/* Master */}
        <Route
          path="/admin/conteudo"
          element={
            <ProtectedRoute allowedTypes={['Master']}>
              <AdminConteudo />
            </ProtectedRoute>
          }
        />

        {/* Shared routes */}
        <Route
          path="/alterar-senha"
          element={
            <ProtectedRoute allowedTypes={['Cliente', 'Arquiteto', 'Assistente']}>
              <TrocaSenhaObrigatoria />
            </ProtectedRoute>
          }
        />
        <Route
          path="/empreendimentos/:id"
          element={
            <ProtectedRoute allowedTypes={['Cliente', 'Arquiteto', 'Assistente']}>
              <ProjetoDetalhe />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/atividades/:id/apontamento"
          element={
            <ProtectedRoute allowedTypes={['Arquiteto', 'Assistente']}>
              <ApontamentoForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/atividades/:id/historico"
          element={
            <ProtectedRoute allowedTypes={['Cliente', 'Arquiteto', 'Assistente']}>
              <AtividadeDetalhe />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* Catch-all: redirect to landing */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
